export const useCalendar = () => {
    const handleDayClick = (date: Date, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // TODO v2
    };

    return {
        handleDayClick
    };
};
